module.exports = __webpack_public_path__ + "static/media/ballenita.37d257da.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ballenita/ballenita.png
// module id = 329
// module chunks = 0